@if (translationLoadedForTheFirstTime()) {
  <button (click)="openModalAbout(template)" class="about-button-open">
    {{ LABELS.aboutTrueViewButton | translate }}
  </button>
}

<ng-template #template>
  <div class="modal-header modal-header-custom">
    <h2 class="modal-title">
      {{ LABELS.aboutTrueView | translate }}
    </h2>
  </div>

  <div class="modal-body with-scroll modal-body-about">
    <div [innerHTML]="LABELS.aboutTrueViewBody | translate"></div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-light" (click)="modalRef.hide()">{{ LABELS.aboutTrueViewClose | translate }}</button>
  </div>
</ng-template>
